import ReactDOM from 'react-dom';
import React from 'react';
import App from './components/App';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/stylesheets/main.scss';
import 'react-widgets/dist/css/react-widgets.css';



ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
    , document.getElementById('app'));
